import { render, staticRenderFns } from "./FormCardRegister.vue?vue&type=template&id=1e4a6077&scoped=true"
import script from "./FormCardRegister.vue?vue&type=script&lang=ts"
export * from "./FormCardRegister.vue?vue&type=script&lang=ts"
import style0 from "./FormCardRegister.vue?vue&type=style&index=0&id=1e4a6077&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4a6077",
  null
  
)

export default component.exports